import { Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent } from 'src/app/shared/component/icon/svg-icon.component';
import { IconsConstants } from 'src/app/shared/common';
import { NavBarService } from 'src/app/shared/services/nav-bar.service';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { LanguageEnum } from 'src/app/core/common';

@Component({
  selector: 'app-minimal-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    IconSvgComponent
  ],
  templateUrl: './minimal-header.component.html',
  styleUrls: ['./minimal-header.component.scss']
})
export class MinimalHeaderComponent extends BaseComponent implements OnInit {
  languageMenuItems: {language: LanguageEnum}[];
  IconsConstants = IconsConstants;

  constructor(
    injector: Injector,
    private navBarService: NavBarService) { 
    super([], injector);
  }

  ngOnInit(): void {
    this.initializeLanguagesMenuItems();
   }

  toggleSideNav(): void {
    this.navBarService.toggleSideNavBar();
  }

  private initializeLanguagesMenuItems(): void {
    this.languageMenuItems = [
      {
        language: LanguageEnum.Arabic
      },
      {
        language: LanguageEnum.English
      }
    ]
  }
}
